export default __webpack_public_path__ + "static/media/404.5cf383a0.png";